import { z } from 'zod';

/**
 * BCP-47 language tag (e.g. `pt-BR`, `en`, `es`). Loose length-bounded string —
 * we do NOT enumerate locales. Reused by the conversation read schema + translation cache.
 */
export const LanguageCodeSchema = z.string().min(2).max(35);
export type LanguageCode = z.infer<typeof LanguageCodeSchema>;
